import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type MixedAttendance = ApiSchemas['MixedAttendancePresenter']

export default {
  async list(options?: ApiSchemas['ListMixedAttendanceDto']) {
    return wrapEndpoint(() =>
      client.GET('/mixed-attendance', {
        params: {
          query: options,
        },
      }),
    )
  },
}
